var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "reviews-thumbs"
  }, [_c('span', {
    staticClass: "reviews-thumbs__positive",
    class: [{
      'reviews-thumbs__positive_is-active': _vm.activeLike
    }],
    attrs: {
      "data-e2e": "reviews-thumbs-positive"
    },
    on: {
      "click": _vm.onPositive
    }
  }, [_vm._v("\n    " + _vm._s(_vm.like) + "\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "reviews-thumbs__negative",
    class: [{
      'reviews-thumbs__negative_is-active': _vm.activeDislike
    }],
    attrs: {
      "data-e2e": "reviews-thumbs-negative"
    },
    on: {
      "click": _vm.onNegative
    }
  }, [_vm._v("\n    " + _vm._s(_vm.dislike) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }